import {
    parseNumber,
    receiveBoolean,
    receiveNumber,
    receiveObject,
    receiveString,
} from "../../../../controllers/adapters/receives"

const PersonasAdapters = {

    // GET /integra-web/empresas/personas/disponibles
    // Personas asignadas a la empresa (el usuario debe estar autorizado en ella).
    // Respuesta del backend:
    //   axios res -> data = { status, message, code, data: PaginaBackendResponse }
    //   Cada elemento trae el registro de `integra_clientes_personas` más
    //   `nombre` (nombre + apellidos), `email` y `nif` de la persona, y la fila
    //   entera de `integra_personas_fisicas` en `persona_fisica`.
    GET_DISPONIBLES: {

        receive: {

            schema: function (item: any = {}) {

                return {
                    id: receiveNumber(item.id),
                    cliente_id: receiveNumber(item.cliente_id),
                    usuario_id: receiveNumber(item.usuario_id),
                    nombre: receiveString(item.nombre),
                    nif: receiveString(item.nif),
                    email: receiveString(item.email),
                    estado: receiveString(item.estado),
                    autorizada: receiveBoolean(item.estado === 'autorizada'),
                    authorized: receiveBoolean(item.authorized),
                    origen: receiveString(item.origen),
                    // Fila completa de `integra_personas_fisicas`. El backend la
                    // adjunta con `row_to_json(...)` y se conserva tal cual (sin
                    // re-mapear) porque es la que el WS d'Activitats necesita para
                    // dar de alta o actualizar el `clientes` de la persona al
                    // inscribirla en una actividad.
                    persona_fisica: receiveObject(item.persona_fisica),
                }
            },

            adapter: function (data: any) {

                const paginator = data?.data?.data

                const items = (paginator?.elementos || []).map((item: any) => this.schema(item))

                return {
                    items,
                    numeroElementos: receiveNumber(paginator?.numeroElementos),
                    numeroPagina: receiveNumber(paginator?.numeroPagina),
                    numeroTotalElementos: receiveNumber(paginator?.numeroTotalElementos),
                    totalPages: receiveNumber(paginator?.totalPages),
                    numberOfElements: receiveNumber(paginator?.numberOfElements),
                    first: receiveBoolean(paginator?.first),
                    last: receiveBoolean(paginator?.last),
                    empty: receiveBoolean(paginator?.empty),
                }
            }
        },
    },

    // GET /integra-web/empresas/personas/buscar-persona
    // Búsqueda de personas de `usuarios_ebcn` que aún no están asignadas a la empresa.
    // Parámetros: `q` (nombre/NIF/email) y `empresa_id`. Devuelve un array (máx. 10).
    GET_BUSCAR_PERSONA: {

        receive: {

            schema: function (item: any = {}) {

                return {
                    id: receiveNumber(item.id),
                    nif: receiveString(item.nif),
                    nombre: receiveString(item.nombre),
                    apellidos: receiveString(item.apellidos),
                    email: receiveString(item.email),
                    username: receiveString(item.username),
                }
            },

            adapter: function (data: any) {

                const elementos = Array.isArray(data?.data?.data) ? data.data.data : []

                const items = elementos.map((item: any) => this.schema(item))

                return {
                    items,
                }
            }
        },
    },

    // POST /integra-web/empresas/personas/solicitar
    // Request body: { empresa_id, usuario_id }
    //   `usuario_id` es la persona seleccionada en el buscador (`usuarios_ebcn.id`),
    //   que puede no ser el usuario que hace la petición. El backend no la deduce
    //   de la sesión, así que el front tiene que enviarla.
    // Respuesta:    { status: true, message, code, data }
    POST_SOLICITAR: {

        send: {

            schema: function (item: any = {}) {

                return {
                    empresa_id: parseNumber(item.empresa_id),
                    usuario_id: parseNumber(item.usuario_id),
                }
            },

            adapter: function (data: any) {

                const item = this.schema(data)

                return {
                    ...item
                }
            }
        },

        receive: {

            schema: function (item: any = {}) {

                return {
                    status: receiveBoolean(item?.status),
                    message: receiveString(item?.message),
                    data: receiveObject(item?.data),
                }
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },

    // DELETE /integra-web/empresas/personas/{id}
    // Desvincula a la persona (registro de `integra_clientes_personas`) de la empresa.
    DELETE_PERSONA: {

        receive: {

            schema: function (item: any = {}) {

                return {
                    status: receiveBoolean(item?.status),
                    message: receiveString(item?.message),
                    data: receiveObject(item?.data),
                }
            },

            adapter: function (data: any) {

                const dataTemp = data?.data

                const res = this.schema(dataTemp)

                return res
            }
        },
    },
}

export {
    PersonasAdapters,
}